import type { PropsWithChildren } from 'react';

import { FileViewerPreviewSectionStyled } from './styles/FileViewerPreviewSectionStyled'

export interface IFileViewerPreviewSectionProps {}

export const FileViewerPreviewSection = ({
  children,
}: PropsWithChildren<IFileViewerPreviewSectionProps>) => {
  return (
    <FileViewerPreviewSectionStyled>{children}</FileViewerPreviewSectionStyled>
  )
}
